export function Header1Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M5 4a1 1 0 011 1v6h4V5a1 1 0 112 0v14a1 1 0 11-2 0v-6H6v6a1 1 0 11-2 0V5a1 1 0 011-1zM16.052 18.53a8.03 8.03 0 00-.413-.015h-1.087a2.91 2.91 0 00-.09.75c0 .245.03.49.09.735h5.34c.03-.11.05-.23.06-.36a3.274 3.274 0 000-.765 1.8 1.8 0 00-.06-.36h-.728a19.634 19.634 0 01-.885.023v-.45c.005-.15.008-.3.008-.45V11.78a3.404 3.404 0 00-.443-.045 5.79 5.79 0 00-.84 0c-.155.005-.307.02-.457.045-.22.455-.528.878-.923 1.268-.39.39-.92.777-1.59 1.162.035.22.118.432.248.637.135.2.3.346.495.436.345-.146.67-.316.975-.51.305-.2.575-.433.81-.698-.015.22-.035.438-.06.652a6.06 6.06 0 00-.03.548v2.812c.005.15.007.3.007.45-.105 0-.247-.002-.427-.007z"
      ></path>
    </svg>
  );
}
